<!-- Static boarding summary: not an expansion control (no body) -->
<div class="!m-0 max-w-full min-w-0 !rounded-none !shadow-none">
  <div class="!bg-[#F3F5F7B2] box-border !shadow-none !px-3 flex w-full min-w-0 max-w-full items-center overflow-x-clip"
    [class]="direction">
    <div class="min-w-0 max-w-full flex-1 basis-0 !box-border py-2">
      <div class="flex max-w-full min-w-0 justify-between gap-2" (click)="handleStationClick(section.departure?.place)">
        <div class="flex min-w-0 flex-1 basis-0 items-center gap-2">
          <ng-icon name="bus" class="section-icon shrink-0 text-2xl relative border-2 border-solid border-primary p-2"
            [ngClass]="{
              'section-icon--first': index == 0,
              'section-icon--last': index == length - 1
            }" style="border-radius: 50%" />

          <span class="flex flex-col gap-[0.125rem] min-w-0">
            <span class="font-normal text-sm text-[#0C3058]">{{
              onBoardText
              }}</span>
            @if (index === 0 || (prevSection && prevSection.arrival.place.code === section.departure.place.code && prevSection.arrival.place.platformNumber !== section.departure.place.platformNumber)) {
            <span class="!text-base">{{ section.departure.place.name }}</span>
            @if (section.departure.place.code) {
            <span class="font-normal text-sm text-[#0C3058]">{{ stationCodeText }}: {{ section.departure.place.code
              }}
              @if (section.departure.place.platformNumber) {
              <span class="font-normal text-sm text-[#0C3058]">{{ platformText }}: {{ section.departure.place.platformNumber
                }}
              </span>
              }
            </span>
            }
            }
            <div class="grid min-w-0 flex-1 gap-2 px-2 pt-2" style="grid-template-columns: minmax(0, 1fr) max-content">
              <div class="flex min-w-0 flex-col gap-1">
                <div class="flex min-w-0 flex-wrap gap-[0.125rem] items-center">
                  <img [src]="section.agency.name | agencyLogoByName" [attr.alt]="section.agency.name"
                    class="h-6 hover:cursor-pointer" (click)="openContactInfoModal(); $event.stopPropagation()" />
                  <span class="bg-gray px-1 py-0.5 rounded-lg">{{
                    section.transport.name
                    }}</span>
                  @if(section.specialData.isAccessible) {
                  <mot-button [icon]="section.specialData?.isCallNeeded ? 'wheelchair-move-phone' : 'wheelchair-move'"
                    [type]="'icon'" ariaHaspopup="dialog"
                    [ariaLabel]="section.specialData?.isCallNeeded ? accessibleWithOrderTooltipText : accessibleTooltipText"
                    buttonClass="!w-6 !h-6 !min-w-0 !p-0 !rounded-full" iconClass="text-base font-black"
                    [matTooltip]="section.specialData?.isCallNeeded ? accessibleWithOrderTooltipText : accessibleTooltipText"
                    (onClick)="openContactInfoModal(); $event.stopPropagation()" aria-hidden="true"/>
                  }
                  @if(section.specialData.isFlexible) {
                  <mot-button [icon]="'phone'" [type]="'icon'" ariaHaspopup="dialog"
                    buttonClass="!w-6 !h-6 !min-w-0 !p-0 !rounded-full" iconClass="text-base font-black"
                    (onClick)="openContactInfoModal(); $event.stopPropagation()" aria-hidden="true"/>
                  }

                  @if(section.specialData.isOrderInAdvanced) {
                  <mot-button [icon]="'phone'" [type]="'icon'" ariaHaspopup="dialog"
                    [ariaLabel]="orderInAdvancedTooltipText" buttonClass="!w-6 !h-6 !min-w-0 !p-0 !rounded-full"
                    iconClass="text-base font-black" [matTooltip]="orderInAdvancedTooltipText"
                    (onClick)="openContactInfoModal(); $event.stopPropagation()" aria-hidden="true"/>
                  }
                  @if (
                  !!section.specialData.isAccessible &&
                  section.specialData.isRouteMunicipal &&
                  section.transport.mode == 'bus'
                  ) {
                  <ng-icon name="calendar-day" class="text-lg" />
                  }
                  <span class="text-sm font-normal">{{toDirectionText}} {{
                    section.transport.headsign?.replace("_", "/")
                    }}</span>
                </div>
                <!-- contrast: tailwind config text-gray-600 (~2.6:1) fails AA; subText (~4.9:1) passes. -->
              </div>

              @if (!!section.departure.images?.length) {
              <mot-button icon="images" (onClick)="openStationImages(section.departure.images)"
                [text]="stationPictureText" ariaHaspopup="dialog" />
              }
            </div>
            <mot-button [text]="showLineCalendarText" textClass="!text-primary !text-sm !font-normal" (onClick)="pickLine(section.transport.routeId, section.transport.name); $event.stopPropagation()"
                 ariaHaspopup="dialog" />
          </span>
        </div>

        <span class="shrink-0 ps-1 tabular-nums text-[#0C3058]"
          [ngClass]="{ '!text-[#008667]': section.departure.realTimeString }">{{
          (section.departure.realTimeString ||
          section.departure.hourTimeString) | hour
          }}</span>
      </div>
    </div>
  </div>
</div>

@if (!!section.intermediateStops && !!section.intermediateStops.length) {
<mat-expansion-panel class="!m-0 !rounded-none !bg-transparent !shadow-none" [class]="direction">
  <mat-expansion-panel-header class="!bg-transparent !shadow-none !px-6 !min-h-12">
    <mat-panel-title class="!m-0 text-primary !gap-6 !px-2">
      <mat-divider [vertical]="true" color="primary" class="!border-r-solid !border-r-primary h-full"
        style="margin-right: 1px; margin-left: 1px" />
      <div class="flex items-center h-full pt-2">
        <span class="flex text-primary gap-2 items-center">
          <span class="text-sm font-normal text-[#0068F5]">{{ section.intermediateStops.length + 1 }} {{ stationsText
            }}</span>
          <span class="text-subText text-sm" aria-hidden="true">•</span>
          <span class="text-sm font-normal text-[#0068F5]">{{
            calculatedSectionDurationText
            }}</span>
        </span>
      </div>
    </mat-panel-title>
  </mat-expansion-panel-header>
  <div class="flex flex-col gap-2 px-8">
    @for (
    stop of section.intermediateStops; track
    stop; let intermdiateStopIndex = $index; let isLastStop = $last) {
    <div class="flex justify-between">
      <div class="flex gap-5 items-center">
        <app-stop-indicator [isLastStop]="false" class="!h-full" topLineClass="!h-1/2" bottomLineClass="!h-1/2" />
        <span class="stop-name text-[#0C3058] !text-sm cursor-pointer"
          [ngClass]="{'!text-[#D4282E] !line-through': stop.departure.place.isStationCanceled, '!text-[#008667]': stop.departure.place.isAlternative}"
          (click)="handleStationClick(stop.departure.place)">{{stop.departure.place.name}} -
          {{stop.departure.place.code}}</span>
      </div>
      <!-- <span class="font-normal text-xs text-[#0C3058] flex items-center" [ngClass]="{'!text-[#008667]': stop.departure.realTimeString}">{{
                        stop.departure.realTimeString || stop.departure.hourTimeString | hour
                      }}</span> -->
    </div>
    }
  </div>
</mat-expansion-panel>
} @else {
<div class="!m-0 !rounded-none !bg-transparent !shadow-none" [class]="direction">
  <div class="!bg-transparent !shadow-none !px-6">
    <div class="!m-0 text-primary !gap-6 !px-2 flex items-center" [class]="direction">
      <mat-divider [vertical]="true" color="primary" class="!border-r-solid !border-r-primary h-full"
        style="margin-right: 1px; margin-left: 1px" />
      <div class="flex items-center h-full pt-2 pb-2">
        <span class="flex text-primary gap-2 items-center">
          <span class="text-sm font-normal text-[#0068F5]">{{ oneStationText }}</span>
          <span class="text-subText text-sm" aria-hidden="true">•</span>
          <span class="text-sm font-normal text-[#0068F5]">{{
            calculatedSectionDurationText
            }}</span>
        </span>
      </div>
    </div>
  </div>
</div>
}

<!-- Arrival destination information - Always visible -->
<mat-expansion-panel #arrivalPanel hideToggle class="!m-0 !rounded-none !shadow-none">
  <mat-expansion-panel-header class="!shadow-none !px-6 !min-h-16 !h-auto !box-border">
    <mat-panel-title class="!m-0 text-primary !gap-6 !px-2" [class]="direction">
      <app-stop-indicator [isLastStop]="false" class="!h-full" topLineClass="!h-1/2" bottomLineClass="!h-1/2" />
      <div class="flex flex-col w-full !box-border py-2" (click)="handleStationClick(section.arrival?.place)">
        <span class="font-normal text-sm text-[#0C3058] block" [class.text-right]="direction === 'rtl'">{{
          boardOffText
          }}</span>
        <div class="flex items-center h-full">
          <span class="flex text-primary gap-2 items-center">
            <span class="text-base text-[#0C3058]">{{section.arrival.place.name}} -
              {{section.arrival.place.code}}
              @if (section.arrival.place.platformNumber) {
                <span class="text-base text-[#0C3058]">{{ platformText }} : {{ section.arrival.place.platformNumber
                  }}
                </span>
                }
            </span>
            <span class="text-subText text-sm" aria-hidden="true">•</span>
            <span class="text-sm font-normal text-[#000000]" [class.justify-end]="direction === 'ltr'"
              [ngClass]="{'!text-[#008667]': section.arrival.realTimeString}">{{
              section.arrival.realTimeString || section.arrival.hourTimeString | hour
              }}</span>
          </span>
        </div>
      </div>
    </mat-panel-title>
  </mat-expansion-panel-header>
  <!-- <div class="flex flex-col gap-2 px-8">
                  <div class="flex justify-between">
                    <div class="flex gap-5 items-center">
                      <div class="flex flex-col gap-2">
                        <span
                          *ngIf="section.arrival.place.code"
                          class="font-normal text-xs text-[#0C3058]"
                          >{{ stationCodeText }}: {{ section.arrival.place.code }}</span
                          >
                        </div>
                      </div>
                    </div>
                  </div> -->
</mat-expansion-panel>

<!-- <mat-divider
                [vertical]="true"
                color="primary"
                class="h-4 !border-solid !border-t-0 !border-b-0"
    [ngClass]="{
      ' !border-r-primary': direction === 'rtl',
      '!border-l-2 !border-l-primary': direction === 'ltr'
    }"
    [ngStyle]="
      direction === 'rtl'
        ? { 'margin-right': 'calc(2rem + 1px)' }
        : { 'margin-left': 'calc(2rem + 1px)' }
    "
                /> -->